import { create } from 'zustand';

interface UIState {
  siderCollapsed: boolean;
  toggleSider: () => void;
  setSiderCollapsed: (collapsed: boolean) => void;
}

// UI 状态 Store
export const useUIStore = create<UIState>((set) => ({
  siderCollapsed: false,

  toggleSider: () => set((state) => ({ siderCollapsed: !state.siderCollapsed })),

  setSiderCollapsed: (collapsed) => set({ siderCollapsed: collapsed }),
}));
